import React from 'react'
import { BrowserRouter } from 'react-router-dom'

const AgTechWebNavigationContext = (props: { children: JSX.Element }) => {
    return (
        <BrowserRouter>
            {props.children}
        </BrowserRouter>
    )
}

export default React.memo(AgTechWebNavigationContext);